import http from './http.js';

export function getFarmDiagnoseList(farm_id,area_id,year){
    return http.get(`/user/farm/get_farm_diagnose_list/`+farm_id+'/'+area_id+'/'+year)
}
export function saveFarmDiagnose(diagnose_id,params){

    return http.post(`/user/farm/save_farm_diagnose/`+diagnose_id,params)
}

export function getDiagnoseRuleList(diagnose_id,area_id){
    return http.get(`/data/rule/get_diagnose_list/`+diagnose_id+'/'+area_id)
}

export function createFarmDiagnose(params){
    return http.post(`/user/farm/create_farm_diagnose`,params)
}
